
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 22 23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.999 15.625a6.875 6.875 0 100-13.75 6.875 6.875 0 000 13.75z","stroke":"#ABAFB5","stroke-width":"1.2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M10.999 12.875a4.125 4.125 0 100-8.25 4.125 4.125 0 000 8.25zM15.125 14.25v6.875l-4.126-2.063-4.124 2.063V14.25","stroke":"#ABAFB5","stroke-width":"1.2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    